import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { queryCache, useMutation } from "react-query";

import { Button, showNotification } from "fe-shared/src/components";
import { CloseIcon } from "fe-shared/src/components/Icons";
import { PickupRequestMaterial } from "fe-shared-requests/src/types";
import { formatRequestNumber as formatTransactionNumber } from "fe-shared-requests/src/helpers/format";

import { REQUESTS_QUERY_KEY, REQUEST_ACTIVITIES_QUERY_KEY } from "consts";
import PickupRequestLinkTransactionModal from "components/PickupRequestLinkTransactionModal";

import * as api from "./modules/api";

interface Props {
  requestNumber: string;
  collectorName: string;
  materials: PickupRequestMaterial[];
}

const PickupRequestLinkTransactionButton = (props: Props) => {
  const { requestNumber, collectorName, materials } = props;
  const { t } = useTranslation();
  const [isModalActive, setIsModalActive] = useState(false);

  const [link, linkResult] = useMutation(
    (transactionNumber: string) =>
      api.linkPickupRequestTransaction(requestNumber, transactionNumber),
    {
      onSuccess: (_data, transactionNumber) => {
        setIsModalActive(false);
        queryCache.invalidateQueries(REQUESTS_QUERY_KEY);
        queryCache.invalidateQueries([
          REQUEST_ACTIVITIES_QUERY_KEY,
          requestNumber,
        ]);
        showNotification(
          t("pickupRequests.details.linkTransactionSuccess", {
            transactionNumber: formatTransactionNumber(transactionNumber),
          })
        );
      },
      onError: () => {
        showNotification(
          t("pickupRequests.details.linkTransactionError"),
          undefined,
          CloseIcon
        );
      },
    }
  );

  return (
    <>
      <Button
        id="request-link-transaction-button"
        disabled={linkResult.isLoading}
        onClick={() => setIsModalActive(true)}
      >
        {t("pickupRequests.details.linkTransaction")}
      </Button>
      <PickupRequestLinkTransactionModal
        isActive={isModalActive}
        requestNumber={requestNumber}
        collectorName={collectorName}
        materials={materials}
        isSubmitting={linkResult.isLoading}
        onConfirm={link}
        onCancel={() => setIsModalActive(false)}
      />
    </>
  );
};

export default PickupRequestLinkTransactionButton;
